// src/features/commission/components/CommissionTable.tsx
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { Commission } from '../types/commission.types';
import { CommissionStatusBadge } from './CommissionStatusBadge';

export interface CommissionTableProps {
  commissions: Commission[];
}

/**
 * Commission list table. Presentation only — takes its rows as a prop
 * instead of reading useCommissionMock itself, so it stays decoupled
 * from where the data comes from; a later phase's real commission
 * hook can feed the same `commissions` prop without this component
 * changing. Same shape as orders/components/OrderTable.tsx and
 * services/components/ServiceTable.tsx: wrapped in the shared
 * glass-card `Card` primitive (noPadding, table owns its own cell
 * padding) with a horizontal-scroll rail for narrow viewports.
 *
 * Rows are clickable and call navigate(`/commission/${commission.id}`),
 * which resolves to the CommissionWorkspacePage foundation route.
 */
export function CommissionTable({ commissions }: CommissionTableProps) {
  return (
    <div className="vania-commission-table-scroll">
        <table className="vania-commission-table">
          <thead>
            <tr>
              <th>نماینده</th>
              <th>شناسه</th>
              <th>موبایل</th>
              <th>تننت</th>
              <th>شناسه تننت</th>
              <th>مبلغ</th>
              <th>وضعیت</th>
              <th>تاریخ</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {commissions.map((commission) => (
              <tr
                key={commission.id}
                className="vania-commission-table-row"
              >
                <td className="vania-commission-table-name">{commission.representative_name || commission.mobile || commission.representative_id}</td>
                <td dir="ltr">{formatPersianNumber(commission.representative_id)}</td>
                <td dir="ltr">{commission.mobile || '-'}</td>
                <td>{commission.tenant_name || commission.tenant_id || '-'}</td>
                <td dir="ltr">{commission.tenant_id == null ? '-' : formatPersianNumber(commission.tenant_id)}</td>
                <td dir="ltr">{formatPersianNumber(commission.amount)}</td>
                <td>
                  <CommissionStatusBadge status={commission.status} />
                </td>
                <td dir="ltr">{formatSolarDate(commission.created_at || '-')}</td>
                <td><Link className="vania-commission-row-action" to={`/commission/${commission.id}`} aria-label="مشاهده کمیسیون" title="مشاهده"><Eye size={14} aria-hidden="true" /><span className="sr-only">مشاهده</span></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
}
